import React, {useEffect, useRef, useState} from "react";
import './style.css';
import {YMaps, Map, Placemark, ZoomControl} from '@pbe/react-yandex-maps';
import ModalImageGallery from "../../components/ModalImageGallery";
import {Image} from "semantic-ui-react";
import {useSelector} from "react-redux";
import {getLanguage} from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import SadIcon from "../../icons/sad-icon.png";
import {getTypeExhibition} from "../Home/reducer";


export default function DescriptionCongress(props) {
    const { mixpanel } = props

    useEffect(() => {
        window.scrollTo(0, 0);
        if (mixpanel) {
            mixpanel.track('View. Description Congress')
        }
    }, []);

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const [modalActive, setModalActive] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));

    const modalImageGallery = () => (
        <ModalImageGallery
            open={modalActive}
            handleOpen={() => setModalActive(true)}
            handleClose={() => setModalActive(false)}
            images={[
                {
                    original: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_1-scaled.jpeg",
                    thumbnail: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_1-scaled.jpeg",
                },
                {
                    original: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_3-scaled.jpeg",
                    thumbnail: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_3-scaled.jpeg",
                },
                {
                    original: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_2-scaled.jpeg",
                    thumbnail: " https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_2-scaled.jpeg",
                },
            ]}
            showAsGallery={false}
            index={imageIndex}
        />);

    const onImgClick = (index) => {
        setImageIndex(index);
        setModalActive(true);
    }

    const GalleryCongress = () => {
        if (navigator.onLine) {
            return (
                <>
                    <Image src='https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_1-scaled.jpeg'
                           className='picture-congress' onClick={() => (onImgClick(0))}/>
                    <Image src='https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_3-scaled.jpeg'
                           className='picture-congress' onClick={() => (onImgClick(1))}/>
                    <Image src='https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_2-scaled.jpeg'
                           className='picture-congress' onClick={() => (onImgClick(2))}/>
                </>
            )
        } else {
            return (
                <div className='view-images'>
                    <img src={SadIcon} alt={""}/>
                    <span className='text-bookmark'>{languageString === 'ru'
                        ? 'Для просмотра изображений, пожалуйста, подключитесь к интернету'
                        : 'To view the images, please connect to the Internet'}</span>
                </div>
            )
        }
    }

    // Заменить секцию textData в компоненте DescriptionCongress:
    const textData = {
        asia: {
            about_1: t('aboutTheCongressOneAsia'),
            about_2: t('aboutTheCongressTwoAsia'),
            block_exhibition: () => (<><b>{t('exh')}</b> {t('blockCongressOneAsia')}</>),
            block_business: t('blockCongressTwoAsia'),
            block_culture: t('blockCongressThreeAsia'),
            gallery: GalleryCongress(),
            directions: () => {
                const directionsList = [
                    t('directionFeedAdditives'),
                    t('directionVeterinary'),
                    t('directionAnimalEquipment'),
                    t('directionFeedEquipment'),
                    t('directionMilkProcessing'),
                    t('directionCropStorage'),
                    t('directionPlantGrowing'),
                    t('directionAgriculturalMachinery'),
                    t('directionRussianFarms'),
                    t('directionGenetics'),
                    t('directionBiotechnology'),
                    t('directionLabEquipment'),
                    t('directionAgroServices'),
                    t('directionInnovationExchange'),
                    t('directionIT'),
                    t('directionHorseBreeding'),
                    t('directionAquaculture'),
                    t('directionPigFarming'),
                    t('directionPoultryFarming'),
                    t('directionFoodBeverages'),
                ];

                const itemsPerColumn = Math.ceil(directionsList.length / 3);
                const columns = [];
                for (let i = 0; i < 3; i++) {
                    columns.push(directionsList.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn));
                }

                return (
                    <div className="directions-container">
                        {columns.map((column, columnIndex) => (
                            <div key={columnIndex} className="directions-column">
                                <ul>
                                    {column.map((item, itemIndex) => (
                                        <li key={itemIndex}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                );
            },
            date: {
                period: t('oc1_3'),
                days: [t('oc1'), t('oc2'), t('oc3')],
            },
            location: {
                locationTexts: [
                    t('sirius'),
                    t('univerSirius'),
                    t('afterGames'),
                    t('exhComplex'),
                ],
                coordinates: [43.414713, 39.950758],
            }
        },
        gras: {
            about_1: t('aboutTheCongressOneGras'),
            about_2: '',
            block_exhibition: () => (
                <>
                    {t('forumIncludes')}
                    <ul>
                        <li>{t("blockPlenar")}</li>
                        <li>{t("blockSession")}</li>
                        <li>{t("blockPresentation")}</li>
                        <li>{t("blockMatchmaking")}</li>
                        <li>{t("blockVisit")}</li>
                    </ul>
                </>
            ),
            block_business: '',
            block_culture: '',
            gallery: '',
            directions: () => (
                <>
                    {[
                        [t('directionPracticTitle'), t('directionPractic')],
                        [t('directionScienceTitle'), t('directionScience')],
                        [t('directionMatchmakingTitle'), t('directionMatchmaking')],
                    ].map(item => (<div><span style={{fontWeight: 'bold'}}>{item[0]}</span>{item[1]}</div>))}
                </>
            ),
            date: {
                period: t('june30_july2'),
                days: [t('june30'), t('july1'), t('july2')],
            },
            location: {
                locationTexts: [
                    t('locationCenterGras'),
                ],
                coordinates: [55.751367, 37.565441],
            }
        }
    }


    const mapRef = useRef();

    useEffect(() => {
        if (mapRef.current && textData[typeExhibition]?.location?.coordinates) {
            const map = mapRef.current;
            map.setCenter(textData[typeExhibition].location.coordinates, 15, {
                duration: 300
            });
        }
    }, [typeExhibition, textData]);

    const defaultState = {
        center: textData[typeExhibition].location.coordinates,
        zoom: 15,
        controls: [],
    };



    return (
        <>
            <div className="container">
                <div id='cong-title ' className={`title-text text-color-${typeExhibition}`}>{t('aboutCongressTitle')}</div>
                <div className="main-text">
                    {textData[typeExhibition].about_1}
                </div>
                <div className="main-text">
                    {textData[typeExhibition].about_2}
                </div>

                <div className={'cong-indent'}></div>

                <div className={`title-text text-color-${typeExhibition}`}>{t('congressBlocks')}</div>
                <div className="main-text">
                    {textData[typeExhibition]?.block_exhibition !== "" &&
                        <>
                            {textData[typeExhibition].block_exhibition()}
                        </>
                    }
                </div>
                <div className="main-text">
                    {textData[typeExhibition]?.block_business !== "" &&
                        <>
                            <b>{t('busProgram')}</b> {textData[typeExhibition].block_business}
                        </>
                    }
                </div>
                <div className="main-text">
                    {textData[typeExhibition]?.block_culture !== "" &&
                        <>
                            <b>{t('culProgram')}</b> {textData[typeExhibition].block_culture}
                        </>
                    }
                </div>

                <div className='pictures-congress'>
                    {textData[typeExhibition]?.gallery}
                </div>

                <div className={'cong-indent'}></div>

                {
                    <>
                        <div className={`title-text text-color-${typeExhibition}`}>{t('exhibitionDirections')}</div>
                        <div className="main-text">
                                {textData[typeExhibition].directions()}
                        </div>
                    </>
                }


                <div className={`title-text text-color-${typeExhibition}`}>{t('dateEvent')}</div>
                <div id='event-date' className="main-text"><b>{textData[typeExhibition].date.period}</b></div>

                {/*<div className={`subtitle-text text-color-${typeExhibition}`}>{t('congressHours')}</div>*/}
                {/*<>*/}
                {/*    {*/}
                {/*        textData[typeExhibition].date.days.length !== 0 &&*/}
                {/*            textData[typeExhibition].date.days.map(item =>*/}
                {/*                <div id='event-time' className="main-text">{item}</div>*/}
                {/*            )*/}
                {/*    }*/}
                {/*</>*/}

                <div className={'cong-indent'}></div>

                <div className={`title-text text-color-${typeExhibition}`}>{t('locationEvent')}</div>
                <>
                    {
                        textData[typeExhibition].location.locationTexts.length !== 0 &&
                            textData[typeExhibition].location.locationTexts.map((item, index) =>
                                <div className='main-text'>
                                    {index === 0 ? <b>{item}</b> : item}
                                </div>
                            )
                    }
                </>
                <div className={'ymap'}></div>
                {navigator.onLine ?
                    (<YMaps query={languageString === "en" ? { lang: 'en_RU' } : { lang: "ru_RU"}}>
                        <Map
                            defaultState={defaultState}
                            width={"100%"}
                            instanceRef={mapRef}
                        >
                            <ZoomControl options={{float: "right"}}/>
                            <Placemark geometry={textData[typeExhibition].location.coordinates} />
                        </Map>
                    </YMaps>) : (
                        // <div>
                        //     {languageString === 'ru'
                        //         ? 'Для просмотра карты, пожалуйста, подключитесь к интернету'
                        //         : 'To view the map, please connect to the Internet'}
                        // </div>
                        <div className='view-map'>
                            <img src={SadIcon} alt={""}/>
                            <span className='text-bookmark'>{languageString === 'ru'
                                ? 'Для просмотра карты, пожалуйста, подключитесь к интернету'
                                : 'To view the map, please connect to the Internet'}</span>
                        </div>
                    )}
            </div>
            {modalImageGallery()}
        </>
    );
}